import React, { useReducer, useEffect, useContext, useState } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { Layout, BackTop, message } from "antd";
import { ActionGetBalance, ActionLogout } from "../redux/actions";
import routes from "../routes";
import routeTenant from "../routes/tenantRoutes.js";
import menus from "../routes/menus";
import menuTenant from "../routes/tenantMenus.js";
import useMediaModel from "../models/useMedia";
import AppHeader from "./AppHeader.jsx";
import AppAside from "./AppAside.jsx";
import { ActionGetTimezone } from "../redux/actions/index.js";
import {
  ActionGetTenant,
  ActionGetCompany,
  ActionGetCustomer,
} from "../redux/actions/actionUsers.js";
import AppFooter from "./AppFooter.jsx";
import { useSiderMenuToggleModel } from "../models/useToggle";
import { useDispatch, useSelector } from "react-redux";
import { loggedIn } from "../utils/AuthService";
import { CompanyContext } from "../pages/userpersonal/companyContext.js";
import { ActionGetLiveDetails } from "../redux/actions/actionLiveStatus.js";
import defaultFav from "../assets/images/default_favicon.png";

const { Content } = Layout;
const MENU_TOGGLE = "menutoggle";
const reducer = (state, action) => {
  switch (action.type) {
    case MENU_TOGGLE:
      return { ...state, menutoggle: !state.menutoggle };
    default:
      return state;
  }
};

const DefaultLayout = (props) => {
  const menuCollapsed = useSiderMenuToggleModel();
  const { companyDetails } = useContext(CompanyContext);
  const reduxdispatch = useDispatch();
  const isMobile = useMediaModel();
  const auth = useSelector((state) => state.auth.authenticated);
  const role_id = parseInt(auth.role, 10);
  const url = new URL(window.location.href);
  var pathSegments = url.pathname.split("/");
  var viewTenant = url.pathname.indexOf("view-tenant") > -1 ? true : false;
  var tenantId = pathSegments[2];
  const key = `tenant_${tenantId}`;
  const selectedTenant = JSON.parse(localStorage.getItem(key)) || null;
  
  const favIcon = document.getElementById("dynamic-favicon");
  if (favIcon) {
    favIcon.href = companyDetails?.favicon || defaultFav;
    favIcon.onerror = () => {
      favIcon.href = defaultFav;
    };
  }

  useEffect(() => {
    if (loggedIn()) {
      reduxdispatch(ActionGetLiveDetails());
      if (role_id === 1) {
        reduxdispatch(ActionGetCompany());
        reduxdispatch(ActionGetTenant());
        reduxdispatch(ActionGetCustomer());
      } else if (role_id === 2) {
        reduxdispatch(ActionGetTenant());
        reduxdispatch(ActionGetCustomer());
      } else if (role_id === 3) {
        reduxdispatch(ActionGetCustomer());
      }
      reduxdispatch(ActionGetTimezone());
      reduxdispatch(ActionGetBalance());
    }
  }, []);

  const tenantRoleId = parseInt(selectedTenant?.role, 10);
  const liveDetails = useSelector((state) => state.liveStatus.livedetails);
  const Tenant = useSelector((state) => state.user?.tenantList);
  const [state, dispatch] = useReducer(reducer, { menutoggle: false });
  const menuClick = () => {
    dispatch({ type: "menutoggle" });
  };
  if (!loggedIn()) {
    return <Redirect to="/login" />;
  } else {
    if (viewTenant && !tenantRoleId && selectedTenant == null) {
      return <Redirect to="/404" />;
    }
  }
  const loginOut = () => {
    reduxdispatch(
      ActionLogout(() => {
        props.history.push("/login");
        message.success("Log Out Successfull!");
      })
    );
  };

  const filterMenusByRole = (menus, roleId) => {
    return menus
      .filter((menu) => menu.auth.includes(roleId))
      .map((menu) => ({
        ...menu,
        subs: menu.subs
          ? menu.subs.filter((sub) => sub.auth.includes(roleId))
          : [],
      }));
  };
  // const menuTenantModified = menuTenant.map(function(item) {
  //   if (item.hasOwnProperty("key")) {
  //     return {
  //       ...item,
  //       key: item.key.replace(":tenantId", tenantId),
  //     };
  //   }
  //   return item;
  // });

  const replaceTenantId = (item, tenantId) => {
    if (item.hasOwnProperty("key")) {
      item.key = item.key.replace(":tenantId", tenantId);
    }
    if (item.hasOwnProperty("subs")) {
      item.subs = item.subs.map((subItem) => {
        if (subItem.hasOwnProperty("key")) {
          subItem.key = subItem.key.replace(":tenantId", tenantId);
        }
        if (subItem.hasOwnProperty("subs")) {
          subItem.subs = subItem.subs.map((subSubItem) =>
            replaceTenantId(subSubItem, tenantId)
          );
        }
        return subItem;
      });
    }
    return item;
  };
  const menuTenantModified = menuTenant.map((item) =>
    replaceTenantId(item, tenantId)
  );

  const filteredMenus =
    viewTenant && tenantRoleId === 3
      ? filterMenusByRole(menuTenantModified, tenantRoleId, tenantId)
      : filterMenusByRole(menus, role_id);

  const filterRoutes = (routes, condition) => {
    return routes?.filter((route) => condition(route));
  };
  const conditionForTenantRoutes = (route) => {
    const path = pathSegments[1];
    return (
      path === "view-tenant" &&
      tenantRoleId === 3 &&
      route.auth.includes(tenantRoleId)
    );
  };

  // const conditionForUserRoutes = (route) => {
  //   return (
  //     (route.auth && route.auth.includes(role_id)) ||
  //     (route.auth && route.auth.includes(tenantRoleId))
  //   );
  // };
  const conditionForUserRoutes = (route) => {
    const path = pathSegments[1];
    return (
      path !== "view-tenant" &&
      role_id === role_id &&
      route.auth.includes(role_id)
    );
  };

  const filteredRoutes =
    viewTenant && tenantRoleId === 3
      ? filterRoutes(routeTenant, conditionForTenantRoutes)
      : filterRoutes(routes, conditionForUserRoutes);

  const renderComponentBasedOnRole = (
    item,
    userRoleId,
    tenantRoleId,
    viewTenant,
    tenantId,
    props
  ) => {
    if (!userRoleId) {
      return <Redirect to="/login" />;
    } else if (viewTenant && tenantRoleId === 3) {
      if (item?.auth && item?.auth.includes(tenantRoleId)) {
        const routePath = item.path
          .replace(":tenantId", tenantId)
          .replace(":id", props.match.params.id);
        return routePath === window.location.pathname ? (
          <item.component {...props} tenantId={tenantId} />
        ) : (
          <Redirect to={routePath} />
        );
      } else {
        return <Redirect to="/404" />;
      }
    } else {
      if (item?.auth && item?.auth.includes(userRoleId)) {
        return <item.component {...props} tenantId={tenantId} />;
      } else {
        return <Redirect to="/404" />;
      }
    }
  };

  return (
    <Layout className="app">
      <BackTop />
      {/* {viewTenant && tenantRoleId === 3 ? ( */}
      <AppAside menutoggle={state.menutoggle} menu={filteredMenus} />
      {/* ) : (
        <AppAside
          menuToggle={state.menuToggle}
          menu={menus.filter((res) => res.auth.includes(role_id))}
        />
      )} */}

      <Layout
        style={
          isMobile
            ? { minHeight: "100vh", transition: "all 0.2s", marginLeft: 0 }
            : menuCollapsed.state
            ? { minHeight: "100vh", transition: "all 0.2s", marginLeft: 80 }
            : { minHeight: "100vh", transition: "all 0.2s", marginLeft: 240 }
        }
      >
        {/* <SocketContext.Provider value={socket}> */}
        <AppHeader
          menuToggle={menuCollapsed.state}
          menuClick={menuClick}
          Tenant={Tenant}
          loginOut={loginOut}
          selectThemeId={props.selectThemeId}
          themeId={props.themeId}
          liveDetails={liveDetails}
        />

        <Content className="content">
          <Switch>
            {filteredRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                render={(props) =>
                  renderComponentBasedOnRole(
                    route,
                    role_id,
                    tenantRoleId,
                    viewTenant,
                    tenantId,
                    props
                  )
                }
              />
            ))}
            ;
          </Switch>
        </Content>
        <AppFooter />
        {/* </SocketContext.Provider> */}
      </Layout>
    </Layout>
  );
};

export default withRouter(DefaultLayout);
